var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 30,
    height: 30,
    rx: 7,
    fill: "#D0BCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11553 19.3837C6.37184 18.4175 6 17.9345 6 16.5C6 15.0655 6.37184 14.5825 7.11553 13.6163C8.60047 11.6871 11.0908 9.5 14.75 9.5C18.4092 9.5 20.8995 11.6871 22.3845 13.6163C23.1282 14.5825 23.5 15.0655 23.5 16.5C23.5 17.9345 23.1282 18.4175 22.3845 19.3837C20.8995 21.3129 18.4092 23.5 14.75 23.5C11.0908 23.5 8.60047 21.3129 7.11553 19.3837Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.5C17 17.6046 16.1046 18.5 15 18.5C13.8954 18.5 13 17.6046 13 16.5C13 15.3954 13.8954 14.5 15 14.5C16.1046 14.5 17 15.3954 17 16.5Z",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.3ee8f1f0e292c8210c64a1d28be6f3fc.svg";
export { ForwardRef as ReactComponent };